import type { ReservationPolicy } from '@wineryxplorer/shared';

interface ReservationChipProps {
  requiresReservation: boolean;
  venuePolicy: ReservationPolicy | null;
}

// Three states with restrained, hierarchical visual weight.
// Required: filled burgundy (rare editorial accent for urgent / at-capacity).
// Recommended: neutral outline.
// Drop-ins: text-only.
export const ReservationChip = ({ requiresReservation, venuePolicy }: ReservationChipProps) => {
  const effective: ReservationPolicy = requiresReservation
    ? 'required'
    : venuePolicy === 'required'
      ? 'recommended'
      : (venuePolicy ?? 'drop-ins-welcome');

  if (effective === 'required') {
    return (
      <span className="inline-flex items-center text-[0.65rem] font-sans font-medium tracking-widest uppercase px-2 py-0.5 rounded-full bg-secondary-700 text-white">
        Reservation Required
      </span>
    );
  }
  if (effective === 'recommended') {
    return (
      <span className="inline-flex items-center text-[0.65rem] font-sans font-medium tracking-widest uppercase px-2 py-0.5 rounded-full border border-gray-400 text-gray-700">
        Reservations Recommended
      </span>
    );
  }
  return (
    <span className="inline-flex items-center text-[0.65rem] font-sans tracking-widest uppercase text-gray-500">
      Drop-ins Welcome
    </span>
  );
};
